<template>
  <div class="proposeList" :class="activeClass">
    <!-- <div class="header">
        <img src="@/assets/new/fan.png"  @click="goHome" alt="">
        <span>我的奖励</span>
    </div> -->
    <div class="mhead">
      <img
          :src="avatar ? avatar : '@/assets/c/img_tx.png'"
          class="tx"
          alt=""
      />
      <div class="mhright" style="margin-top: 10px">
                <span class="xm" style="font-size: 14px">{{
                    show_address
                  }}</span>
        <span class="time">{{ timer }}</span>
        <!-- <van-count-down :time="nowTime" format="Year:MM:DD:HH:mm:ss:" /> -->
      </div>
    </div>
    <div class="mnav">
      <div class="mitem" @click="setIsshuju">
        <img src="@/assets/c/mone.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.shuju") }}</span>
        <img
            src="@/assets/c/xia.png"
            class="xia"
            alt=""
            v-if="!isshuju"
        />
        <img
            src="@/assets/c/shang.png"
            class="xia"
            alt=""
            v-if="isshuju"
        />
      </div>
      <!-- 数据统计 -->
      <div
          class="shuview"
          style="overflow: hidden; transition: height 0.5s"
          :style="isshuju ? 'height:246px' : 'height:0px'"
      >
        <div class="shuitem">
          <img src="@/assets/c/sone.png" class="sone" alt=""/>
          <div class="shuright">
            <span class="lname">{{ $t("new.liudong") }}</span>
            <span class="lmiao">{{ mobility }}</span>
          </div>
        </div>
        <div class="shuitem">
          <img src="@/assets/c/stwo.png" class="sone" alt=""/>
          <div class="shuright">
            <span class="lname">{{ $t("new.chiyou") }}</span>
            <span class="lmiao">{{ gmc_balance_all }}</span>
          </div>
        </div>
        <div class="shuitem">
          <img src="@/assets/c/sthree.png" class="sone" alt=""/>
          <div class="shuright">
            <span class="lname">{{ $t("new.getong") }}</span>
            <span class="lmiao">${{ self_consumption }}</span>
          </div>
        </div>
        <div class="shuitem">
          <img src="@/assets/c/sfour.png" class="sone" alt=""/>
          <div class="shuright">
            <span class="lname">{{ $t("new.geji") }}</span>
            <span class="lmiao">${{ self_motivate }}</span>
          </div>
        </div>
        <div class="shuitem">
          <img src="@/assets/c/sfive.png" class="sone" alt=""/>
          <div class="shuright">
            <span class="lname">{{ $t("new.taunji") }}</span>
            <span class="lmiao">{{ team_number }}</span>
          </div>
        </div>
      </div>
      <div class="mitem" @click="isyuyan = !isyuyan">
        <img src="@/assets/c/mtwo.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.yushe") }}</span>
        <img
            src="@/assets/c/xia.png"
            class="xia"
            alt=""
            v-if="!isyuyan"
        />
        <img
            src="@/assets/c/shang.png"
            class="xia"
            alt=""
            v-if="isyuyan"
        />
      </div>
      <div
          class="yuview"
          style="overflow: hidden; transition: height 0.5s"
          :style="isyuyan ? 'height:60px' : 'height:0px'"
      >
        <div class="yuitem" @click="getyuyan(2)">
          <img src="@/assets/c/ywen.png" class="zwen" alt=""/>
          <span class="wenname">English</span>
        </div>
        <div class="yuitem" @click="getyuyan(1)">
          <img src="@/assets/c/zwen.png" class="zwen" alt=""/>
          <span class="wenname">繁体中文</span>
        </div>
      </div>
      <div class="mitem" @click="getnav(3)">
        <img src="@/assets/c/mthree.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.Invite") }}</span>
      </div>
      <div class="mitem" @click="getnav(4)">
        <img src="@/assets/c/mfour.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.yaotwo") }}</span>
      </div>
      <div class="mitem" @click="getnav(5)">
        <img src="@/assets/c/icon_swhz.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.yaothree") }}</span>
      </div>
      <div class="mitem" @click="getnav(6)">
        <img src="@/assets/c/msix.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.yaofour") }}</span>
      </div>
      <div class="mitem" @click="gethome">
        <img src="@/assets/c/mseven.png" class="micon" alt=""/>
        <span class="shuju">{{ $t("new.yaofive") }}</span>
      </div>
    </div>
    <div class="botzhan">
      <img
          @click="toUrl(setting.tg)"
          src="@/assets/c/bone.png"
          class="bone"
          alt=""
      />
      <img
          @click="toUrl(setting.c)"
          src="@/assets/c/btwo.png"
          class="bone"
          alt=""
      />
      <img
          @click="toUrl(setting.twitter)"
          src="@/assets/c/bthree.png"
          class="bone"
          alt=""
      />
    </div>
  </div>
</template>

<script>
import {useNumberAnimation, showToast, getToken} from "@/libs/util.js";
import {ajaxData} from "@/api/ajax";

export default {
  props: {
    hideMenu: {
      type: Function,
      default: () => {
      },
    },
    timer: {
      type: String,
      default: "",
    },
    show_address: {
      type: String,
      default: "",
    },
    mobilityBase: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      activeClass: "animate__animated animate__slideInLeft",
      isshuju: false,
      isshujuClass: "animate__animated animate__slideInLeft",
      // show_address: "",
      mobility: "0",
      gmc_balanceBase: "0",
      gmc_balance: "0",
      gmc_balance_allBase: "0",
      gmc_balance_all: "0",
      self_consumptionBase: "0",
      self_consumption: "0",
      self_motivateBase: "0",
      self_motivate: "0",
      team_numberBase: "0",
      team_number: "0",
      isyuyan: false,
      nowTime: "",
      setting: {},
      avatar: sessionStorage.getItem("avatar")
          ? sessionStorage.getItem("avatar")
          : "",
    };
  },
  created() {
    // this.timer = setInterval(this.updateTime, 1000);

    let vm = this;
    vm.getUser();
    vm.getSetting();
  },

  methods: {
    // 显示
    setIsshuju() {
      this.isshuju = !this.isshuju;
      if (this.isshuju) {
        // 播放数字动画
        useNumberAnimation(this.mobilityBase, (num) => {
          this.mobility = num ? num.toFixed(0) : 0;
        });
        useNumberAnimation(this.gmc_balance_allBase, (num) => {
          this.gmc_balance_all = num ? num.toFixed(2) : 0;
        });
        useNumberAnimation(this.self_consumptionBase, (num) => {
          this.self_consumption = num ? parseFloat(num.toFixed(3)) : 0;
        });
        useNumberAnimation(this.self_motivateBase, (num) => {
          this.self_motivate = num ? parseFloat(num.toFixed(3)) : 0;
        });
        useNumberAnimation(this.team_numberBase, (num) => {
          this.team_number = num ? num.toFixed(0) : 0;
        });
      }
    },
    updateTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      this.nowTime =
          `${year}-${month}-${day} ` +
          hours.toString().padStart(2, "0") +
          ":" +
          minutes.toString().padStart(2, "0") +
          ":" +
          seconds.toString().padStart(2, "0");
    },
    getUser() {
      let vm = this;
      ajaxData("/user/info", {}).then((response) => {
        this.mobilityBase = response.data.mobility;
        this.gmc_balance_allBase = response.data.gmc_balance_all;
        this.self_consumptionBase = response.data.self_consumption;
        this.self_motivateBase = response.data.self_motivate;
        this.team_numberBase = response.data.team_number;

        let user = response.data.user;
      });
    },
    getSetting() {
      let vm = this;
      ajaxData("/setting", {key: "default"}).then((response) => {
        this.setting = response.data?.setting;
        this.avatar = response.data?.setting?.avatar;
        sessionStorage.setItem(
            "avatar",
            response.data?.setting?.avatar
        );
      });
    },
    goHome() {
      this.$router.go(-1);
    },
    gethome() {
      this.activeClass = "animate__animated animate__slideOutLeft";
      setTimeout(() => {
        this.hideMenu();
      }, 800);
    },
    getyuyan(e) {
      if (e == 1) {
        //中文
        this.$i18n.locale = "zh";
      } else {
        //英文
        this.$i18n.locale = "en";
      }
      localStorage.setItem("locale", this.$i18n.locale);
      this.$emit("getWorth");
      this.$emit("getNft");
    },
    getnav(e) {
      if (e == 3) {
        this.$router.push({
          path: "/Yaoqing",
        });
        localStorage.setItem("homeMenu", 1);
      } else if (e == 4) {
        this.$router.push({
          path: "/Gonglist",
        });
        localStorage.setItem("homeMenu", 1);
      } else if (e == 5) {
        this.toUrl(this.setting.partner);
      }
      // TODO 这里缺少断开连接的业务
      if (e == 6) {
        showToast(this.$t("disconnect_wallet"));
        delete window.ethereum;
        sessionStorage.removeItem("gmc_ApiAuth");
        sessionStorage.removeItem("address");
        sessionStorage.setItem("isLagout", 1);
        window.location.reload();
      }
    },
    toUrl(url) {
      window.location.href = url;
    },
  },
};
</script>


<style scoped lang="less">
p {
  margin: 0;
  padding: 0;
}

.proposeList {
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: #fff;
  padding: 20px 15px;

  .header {
    height: 50px;
    // margin-bottom: 12px;
    // padding: 40px 12px 0 12px;
    padding: 6px;
    box-sizing: border-box;
    background: rgba(52, 56, 75, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    width: 100%;
    z-index: 10;
    top: 0;

    img {
      width: 55px;
      height: 55px;
      position: absolute;
      left: 10px;
    }

    span {
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .mhead {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tx {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .mhright {
      display: flex;
      flex-direction: column;

      .xm {
        font-weight: bold;
        font-size: 16px;
        color: #000000;
      }

      .time {
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        display: block;
        margin-top: 2px;
      }
    }
  }

  .mnav {
    display: flex;
    flex-direction: column;
    margin-top: 22px;

    .mitem {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;

      .micon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
      }

      .shuju {
        font-weight: bold;
        font-size: 15px;
        color: #000000;
        line-height: 14px;
      }

      .xia {
        margin-left: auto;
        width: 10px;
        height: 10px;
      }
    }

    .shuview {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;

      .shuitem {
        background: #ffffff;
        border-radius: 15px;
        border: 0.5px solid #cccccc;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 12px 9px;
        width: 48%;
        margin-bottom: 10px;

        .sone {
          width: 36px;
          height: 36px;
          margin-right: 10px;
        }

        .shuright {
          display: flex;
          flex-direction: column;

          .lname {
            font-weight: 400;
            font-size: 10px;
            color: #666666;
          }

          .lmiao {
            font-weight: bold;
            font-size: 16px;
            color: #111111;
            display: block;
            margin-top: 2px;
          }
        }
      }

      .shuitem:nth-child(even) {
        margin-left: auto;
      }
    }
  }

  .yuview {
    display: flex;
    flex-direction: column;
    margin: 0px 3px;

    .yuitem {
      height: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .zwen {
        width: 14px;
        height: 8px;
        margin-right: 8px;
      }

      .wenname {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        line-height: 12px;
      }
    }
  }
}

.botzhan {
  margin: 60px 0px 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .bone {
    width: 40px;
    height: 40px;
    margin: 0 20px;
  }
}
</style>
